// This function exists in a standalone file to enable easy mocking of the import.meta.url
export function getCurrentScriptUrl() {
  return new URL(import.meta.url);
}
